import { render, staticRenderFns } from "./NewContentButton.vue?vue&type=template&id=6d71d6d0&scoped=true&"
import script from "./NewContentButton.vue?vue&type=script&lang=js&"
export * from "./NewContentButton.vue?vue&type=script&lang=js&"
import style0 from "./NewContentButton.vue?vue&type=style&index=0&id=6d71d6d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d71d6d0",
  null
  
)

export default component.exports